// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectSettingsComponent } from '@project/components/project/project-settings/project-settings.component';
import { SharedModule } from '@shared/shared.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';

@Component({
  templateUrl: './settings.component.html',
  selector: 'app-settings',
  imports: [
    TranslateModule,
    NgScrollbarModule,
    ProjectSettingsComponent,
    SharedModule
  ]
})
export class SettingsComponent implements OnInit {

  @Input() projectGroup: ProjectGroupVO;
  @Input() isArticleProjectGroup: boolean;

  @Output() public finish = new EventEmitter<ProjectGroupVO>();

  public onClose: Subject<boolean>;
  public isCollapsed: boolean;
  public isCanceling: boolean = false;
  public step: number = 1;

  public scrollbarHeight: number;

  public constructor(private _bsModalRef: BsModalRef) {
    this.isCollapsed = false;
  }

  public ngOnInit(): void {
    this.onClose = new Subject();
    this.scrollbarHeight = window.innerHeight - 240;
  }

  public onConfirm(): void {
    this.finish.emit(this.projectGroup);
  }

  public close(success: boolean): void {
    this.onClose.next(success);
    this._bsModalRef.hide();
  }
}
